module.exports = __webpack_public_path__ + "img/ic-map-full.297e4c66.svg";